/* LB-028 winner (Coframe variant 6a8f5d9790e32e4c6578018b): homepage hero Shop Now buttons + hero restyle. Verbatim served code; section ids matched by prefix/suffix so theme copies don't break it. Safe alongside Coframe (idempotent). */
(()=>{function E(){try{if(globalThis.__COFRAME_DEBUG===!0)return!0}catch{}try{if(/[?&]coframe_debug=1(?:&|#|$)/.test(String(location.search)))return!0}catch{}try{if(localStorage.getItem("coframe_debug")==="1")return!0}catch{}return!1}function _(t){for(var e={},n=["log","info","debug","trace"],r=E(),o={},a=t;a&&a!==Object.prototype;){for(var p=Object.getOwnPropertyNames(a),u=0;u<p.length;u++){var s=p[u];o[s]||s==="constructor"||(o[s]=!0,e[s]=t[s])}a=Object.getPrototypeOf(a)}if(!r)for(var f=0;f<n.length;f++)e[n[f]]=function(){};return e}var l=_(globalThis.console);function m(t,e){if(t)return window.CFQ=window.CFQ||[],window.CFQ.push({emit:"variantRendered"}),!0;window.CFQ=window.CFQ||[];var n={emit:"variantNotRendered"};return e!==void 0&&(n.reason=e),window.CFQ.push(n),l.warn("[cf-variant] render-not-emitted"+(e?": "+e:"")),!1}var x="slideshow--template--25697825161409__slideshow",d=".slideshow__slide",v="data-cf-direct-cta",i=`[${v}]`,h="cf-direct-cta-hero-styles",w="data-cf-hero-height",g=!1,c=null;function $(t){let e=document.createElement("a");return e.setAttribute("href",t),e.setAttribute(v,"true"),e.className="cf:absolute cf:bottom-5 cf:left-1/2 cf:z-10 cf:-translate-x-1/2 cf:whitespace-nowrap cf:rounded-[3px] cf:bg-[#b01717] cf:px-4 cf:py-3 cf:font-[Montserrat,sans-serif] cf:text-[11px] cf:font-semibold cf:uppercase cf:tracking-[0.1em] cf:text-white cf:no-underline cf:shadow-[0_2px_12px_rgba(0,0,0,0.25)] cf:transition-all cf:duration-200 cf:hover:bg-[#8c1212] cf:hover:shadow-[0_4px_16px_rgba(0,0,0,0.35)] cf:focus-visible:outline cf:focus-visible:outline-2 cf:focus-visible:outline-offset-2 cf:focus-visible:outline-white cf:min-[741px]:bottom-11 cf:min-[741px]:px-10 cf:min-[741px]:py-3.5 cf:min-[741px]:text-[15px]",e.textContent="Shop Now",e}function L(t){return`${["",":link",":visited",":hover",":focus",":active"].map(o=>`${t} ${i}${o}`).join(",")}{color:#fff!important;-webkit-text-fill-color:#fff!important;text-decoration:none!important}`}function T(t){return[`${t} ${d}>a:not([data-cf-direct-cta]){display:block;position:relative;overflow:hidden}`,`${t} .box-ratio-custom{position:relative;background-size:100% auto;`,"background-position:center center;background-repeat:no-repeat;","background-attachment:scroll}",`${t} .flickity-viewport{height:calc(100vw / 1.9)!important}`,`${t} .box-ratio-custom[data-cf-bg] img{opacity:0}`,`${t} ${i}{margin:0!important;bottom:23px!important}`,`@media(max-width:740px){${t} ${i}{height:38px!important;`,"padding:0 20px!important;font-size:10px!important;display:flex!important;align-items:center!important;","justify-content:center!important;line-height:1!important}}",L(t),`${t} .flickity-page-dots{position:absolute!important;bottom:6px;left:0;right:0;margin:0!important;z-index:5}`,`${t} .flickity-page-dots .dot{width:7px!important;height:7px!important;margin:0 4px!important}`,"[id^='shopify-section-template--'][id$='__image-gallery'] .gallery__section{margin-top:0!important}"].join("")}function C(t){let e="min(calc(100vh - var(--cf-hero-top,180px) - 85px),calc(100vw / 2.0))";return["@media(min-width:741px){",`${t}{overflow:hidden}`,`${t} ${d}>a:not([data-cf-direct-cta]){height:auto!important;min-height:0}`,`${t} .flickity-viewport{height:${e}!important}`,`${t} .box-ratio-custom{height:${e}!important;padding-bottom:0!important}`,`${t} ${i}{bottom:28px!important}`,"}"].join("")}function M(){let t=`[id^='slideshow--template--'][id$='__slideshow'][${w}]`;return T(t)+C(t)}function H(){if(document.getElementById(h))return;let t=document.createElement("style");t.id=h,t.textContent=M(),document.head.appendChild(t)}function y(){return document.querySelector("[id^='slideshow--template--'][id$='__slideshow']")}function k(){let t=y();return t?Array.from(t.querySelectorAll(d)):[]}function O(t){return t.length===5&&t.every(e=>e.querySelector("a[href]"))}function R(t){return t.indexOf("GIVENCHY")!==-1?"center top":t.indexOf("FEFE")!==-1?"center 85%":"center 50%"}function b(){let t=window.devicePixelRatio||1;return Math.min(3024,Math.ceil(window.innerWidth*t/180)*180)}function I(t){let e=t.currentSrc||t.getAttribute("src")||"";if(e&&e.indexOf("data:")!==0)return e;let n=t.getAttribute("data-src")||"";if(n.indexOf("{width}")!==-1)return n.replace("{width}",String(b()));let r=t.getAttribute("data-original")||"";return r?r.replace(/_\d+x\./,`_${b()}x.`):""}var S="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";function B(t){let e=t.querySelector("img"),n=t.querySelector(".box-ratio-custom");if(!e||!n)return;let r=I(e);if(!r)return;n.getAttribute("data-cf-bg")!==r&&(n.style.backgroundImage=`url("${r}")`,n.setAttribute("data-cf-bg",r)),e.getAttribute("src")||e.setAttribute("src",S);let o=R(r);n.style.backgroundPosition!==o&&(n.style.backgroundPosition=o)}function D(t){let e=t.querySelector("a[href]:not([data-cf-direct-cta])"),n=e&&e.getAttribute("href")||"#";return t.querySelector(i)||t.appendChild($(n)),!!t.querySelector(i)}function F(t){g||(g=!0,c&&(c.disconnect(),c=null),m(t))}function q(t){let e=Math.round(t.getBoundingClientRect().top+window.scrollY);e>0&&t.style.setProperty("--cf-hero-top",`${e}px`)}function A(){try{let t=k();if(!O(t))return;let e=y();if(!e)return;H(),e.setAttribute(w,"1"),t.forEach(B);let r=t.every(D)&&e.querySelectorAll(i).length===5;r&&F(r),q(e)}catch(t){l.error("[cf-variant] LB-028 Direct CTA render error",t)}}function P(){A(),!c&&(c=new MutationObserver(A),c.observe(document.documentElement,{childList:!0,subtree:!0}))}P();})();

(function(){try{for(var t="data-coframe-variant-css",r="v-c678774b5e8a85ee93071f1bbe2239db",o=document.querySelectorAll("style["+t+"]"),a=0;a<o.length;a++){var n=o[a];n.getAttribute(t)===r&&n.parentNode&&n.parentNode.removeChild(n)}var e=document.head||document.documentElement,i=document.createElement("style");i.setAttribute(t,r),i.textContent=`@layer properties;
:root, :host, #variant-root {
  --cf-color-white: #fff;
  --cf-spacing: 0.25rem;
  --cf-font-weight-semibold: 600;
  --cf-default-transition-duration: 150ms;
  --cf-default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.cf\\:absolute, #variant-root .cf\\:absolute {
  position: absolute !important;
}
.cf\\:bottom-5, #variant-root .cf\\:bottom-5 {
  bottom: calc(var(--cf-spacing) * 5) !important;
}
.cf\\:left-1\\/2, #variant-root .cf\\:left-1\\/2 {
  left: calc(1 / 2 * 100%) !important;
}
.cf\\:z-10, #variant-root .cf\\:z-10 {
  z-index: 10 !important;
}
.cf\\:-translate-x-1\\/2, #variant-root .cf\\:-translate-x-1\\/2 {
  --tw-translate-x: calc(calc(1 / 2 * 100%) * -1) !important;
  translate: var(--tw-translate-x) var(--tw-translate-y) !important;
}
.cf\\:rounded-\\[3px\\], #variant-root .cf\\:rounded-\\[3px\\] {
  border-radius: 3px !important;
}
.cf\\:bg-\\[\\#b01717\\], #variant-root .cf\\:bg-\\[\\#b01717\\] {
  background-color: #b01717 !important;
}
.cf\\:px-4, #variant-root .cf\\:px-4 {
  padding-inline: calc(var(--cf-spacing) * 4) !important;
  padding-left: calc(var(--cf-spacing) * 4) !important;
  padding-right: calc(var(--cf-spacing) * 4) !important;
}
.cf\\:py-3, #variant-root .cf\\:py-3 {
  padding-block: calc(var(--cf-spacing) * 3) !important;
  padding-top: calc(var(--cf-spacing) * 3) !important;
  padding-bottom: calc(var(--cf-spacing) * 3) !important;
}
.cf\\:font-\\[Montserrat\\,sans-serif\\],#variant-root .cf\\:font-\\[Montserrat\\,sans-serif\\] {
  font-family: Montserrat,sans-serif !important;
}
.cf\\:text-\\[11px\\], #variant-root .cf\\:text-\\[11px\\] {
  font-size: 11px !important;
}
.cf\\:font-semibold, #variant-root .cf\\:font-semibold {
  --tw-font-weight: var(--cf-font-weight-semibold) !important;
  font-weight: var(--cf-font-weight-semibold) !important;
}
.cf\\:tracking-\\[0\\.1em\\], #variant-root .cf\\:tracking-\\[0\\.1em\\] {
  --tw-tracking: 0.1em !important;
  letter-spacing: 0.1em !important;
}
.cf\\:whitespace-nowrap, #variant-root .cf\\:whitespace-nowrap {
  white-space: nowrap !important;
}
.cf\\:text-white, #variant-root .cf\\:text-white {
  color: var(--cf-color-white) !important;
}
.cf\\:uppercase, #variant-root .cf\\:uppercase {
  text-transform: uppercase !important;
}
.cf\\:no-underline, #variant-root .cf\\:no-underline {
  text-decoration-line: none !important;
}
.cf\\:shadow-\\[0_2px_12px_rgba\\(0\\,0\\,0\\,0\\.25\\)\\],#variant-root .cf\\:shadow-\\[0_2px_12px_rgba\\(0\\,0\\,0\\,0\\.25\\)\\] {
  --tw-shadow: 0 2px 12px var(--tw-shadow-color, rgba(0,0,0,0.25)) !important;
  box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
}
.cf\\:transition-all, #variant-root .cf\\:transition-all {
  transition-property: all !important;
  transition-timing-function: var(--tw-ease, var(--cf-default-transition-timing-function)) !important;
  transition-duration: var(--tw-duration, var(--cf-default-transition-duration)) !important;
}
.cf\\:duration-200, #variant-root .cf\\:duration-200 {
  --tw-duration: 200ms !important;
  transition-duration: 200ms !important;
}
.cf\\:hover\\:bg-\\[\\#8c1212\\], #variant-root .cf\\:hover\\:bg-\\[\\#8c1212\\] {
  &:hover {
    @media (hover: hover) {
      background-color: #8c1212 !important;
    }
  }
}
.cf\\:hover\\:shadow-\\[0_4px_16px_rgba\\(0\\,0\\,0\\,0\\.35\\)\\],#variant-root .cf\\:hover\\:shadow-\\[0_4px_16px_rgba\\(0\\,0\\,0\\,0\\.35\\)\\] {
  &:hover {
    @media (hover: hover) {
      --tw-shadow: 0 4px 16px var(--tw-shadow-color, rgba(0,0,0,0.35)) !important;
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
    }
  }
}
.cf\\:focus-visible\\:outline, #variant-root .cf\\:focus-visible\\:outline {
  &:focus-visible {
    outline-style: var(--tw-outline-style) !important;
    outline-width: 1px !important;
  }
}
.cf\\:focus-visible\\:outline-2, #variant-root .cf\\:focus-visible\\:outline-2 {
  &:focus-visible {
    outline-style: var(--tw-outline-style) !important;
    outline-width: 2px !important;
  }
}
.cf\\:focus-visible\\:outline-offset-2, #variant-root .cf\\:focus-visible\\:outline-offset-2 {
  &:focus-visible {
    outline-offset: 2px !important;
  }
}
.cf\\:focus-visible\\:outline-white, #variant-root .cf\\:focus-visible\\:outline-white {
  &:focus-visible {
    outline-color: var(--cf-color-white) !important;
  }
}
.cf\\:min-\\[741px\\]\\:bottom-11, #variant-root .cf\\:min-\\[741px\\]\\:bottom-11 {
  @media (width >= 741px) {
    bottom: calc(var(--cf-spacing) * 11) !important;
  }
}
.cf\\:min-\\[741px\\]\\:px-10, #variant-root .cf\\:min-\\[741px\\]\\:px-10 {
  @media (width >= 741px) {
    padding-inline: calc(var(--cf-spacing) * 10) !important;
    padding-left: calc(var(--cf-spacing) * 10) !important;
    padding-right: calc(var(--cf-spacing) * 10) !important;
  }
}
.cf\\:min-\\[741px\\]\\:py-3\\.5, #variant-root .cf\\:min-\\[741px\\]\\:py-3\\.5 {
  @media (width >= 741px) {
    padding-block: calc(var(--cf-spacing) * 3.5) !important;
    padding-top: calc(var(--cf-spacing) * 3.5) !important;
    padding-bottom: calc(var(--cf-spacing) * 3.5) !important;
  }
}
.cf\\:min-\\[741px\\]\\:text-\\[15px\\], #variant-root .cf\\:min-\\[741px\\]\\:text-\\[15px\\] {
  @media (width >= 741px) {
    font-size: 15px !important;
  }
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop, #variant-root *, #variant-root ::before, #variant-root ::after, #variant-root ::backdrop {
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-font-weight: initial;
      --tw-tracking: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-duration: initial;
      --tw-outline-style: solid;
    }
  }
}`,e.appendChild(i)}catch(s){console.error("Failed to inject variant CSS",s)}})();
